module.exports = __webpack_public_path__ + "static/media/poweredby_ash.3cf31261.png";